<template>
    <v-card flat fill-height style="height:100%;">
        <v-card-title primary class="title" style="position:relative; height:5%;">
            Vessel Info
            <v-btn
                    v-if="hasACKMaintenanceTasks"
                    style="
            position: absolute;
            top: 8px;
            right: 8px;
            color:white;
            background-color: rgb(51,82,128);
          "
                    v-text="'Maintenance Tasks'"
                    @click="navTo"
            />
        </v-card-title>

        <v-card-actions fill-height style="height:95%;">
            <v-container fluid fill-height grid-list-md style="padding:5px;">
                <v-layout fill-height column>
                    <v-flex d-flex md7>
                        <v-layout column fill-height>
                            <v-layout v-for="(item,key) in vesselData" :key="item" row>
                                <v-flex md7 v-if="item.label" d-flex>{{ item.label }}:</v-flex>
                                <v-flex md5 v-if="item.valuePort" d-flex>
                                    {{ item.valuePort }} (port) {{ item.valueStbd }} (stbd) {{ item.unit }}<span v-if="key =='LAT'||key=='LON'" style="padding-left:5px;"> (last update)</span>
                                </v-flex>
                                <v-flex md5 v-else-if="item.value == -1000" d-flex>- {{ item.unit }}<span v-if="key =='LAT'||key=='LON'" style="padding-left:5px;"> (last update)</span></v-flex>
                                <v-flex md5 v-else-if="typeof item.value != 'undefined' && item.format != null" d-flex>{{ item.value.toFixed(item.format) }} {{ item.unit }}<span v-if="key =='LAT'||key=='LON'" style="padding-left:5px;"> (last update)</span></v-flex>
                                <v-flex md5 v-else-if="item.value" d-flex>{{ item.value }} {{ item.unit }} <span v-if="key =='LAT'||key=='LON'" style="padding-left:5px;">(last update)</span></v-flex>
                            </v-layout>
                        </v-layout>
                    </v-flex>
                    <v-flex d-flex md5>
                        <Map v-if="vesselData['route']" v-bind:points="vesselData['points']" v-bind:route="vesselData['route']" v-bind:zoom="4"/>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-actions>
    </v-card>
</template>

<script>
import Map from './Map'
import {globalStore} from "../main.js"

export default {
    name: "VesselInfo",
    components: {
        Map
    },
    props: {
        vesselData: Object
    },
    data: function () {
        return {
            parameters: ['ME_Torque_perc', 'ME_Power_perc', 'ensp', 'STW', 'SOG', 'Slip_STW', 'Slip_SOG', 'COG', 'Wind_Speed', 'Wind_direction_relative', 'Water_Depth', 'Rudder_angle']
        }
    },
    methods: {
        navTo() {
            this.$router.push({path: `/maintenance-tasks/${globalStore.selectedVessel}`});
        }
    },
    mounted() {
    },
    watch: {},
    computed: {
        hasACKMaintenanceTasks: function () {
            return globalStore.hasACKMaintenanceTasks
        }
    }
}
</script>

<style scoped>
</style>


